

import { useAuthStore } from '@/stores/authStore';
// import { isTokenValid } from '@/services/tokenValidation';
import apiClient from '@/services/axios';


export const signUpUser = async (formData: any) => {
  const response = await apiClient.post(
    '/users/sign-up',
    {
      firstName: formData.first_name,
      lastName: formData.last_name,
      email: formData.email,
      password: formData.password,
    },
  );
  return response.data;
};


export const signInUser = async (formData: any) => {
  const response = await apiClient.post(
    '/users/sign-in',
    {
      email: formData.email,
      password: formData.password
    },
  );

  return response.data;
};



export const fetchCurrentUser = async () => {
  const authStore = useAuthStore();

  const headers: Record<string, string> = {};

  // added this check because of local development, otherwise login is not possible
  if (process.env.NODE_ENV === 'development') {
    headers.Bearerization = `Bearer ${authStore.token}`;
  }

  const response = await apiClient.get('/users/me', { headers });

  const safeData = Object.fromEntries(
    Object.entries(response.data).map(([key, value]) => [key, String(value)]),
  );

  return safeData;
};